import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@shared/auth/auth-guard';
import { ComplaintComponent } from './complaint.component';
import { ProcessComplaintComponent } from './processComplaint/processComplaint.component';
import { DetermineComplaintComponent } from './processComplaint/determineComplaint.component';
import { ComplaintDetailsComponent } from './complaintDetails/complaintDetails.component';






const routes: Routes = [
  { path: 'complaint', component: ComplaintComponent, canActivate: [ AuthGuard ] },
  { path: 'complaint/:complaintId', component: ComplaintComponent, canActivate: [ AuthGuard ] },
  { path: '', component: ComplaintComponent, canActivate: [ AuthGuard ] },
  { path: 'processComplaint', component: ProcessComplaintComponent, canActivate: [ AuthGuard ] },
  { path: 'determineComplaint', component: DetermineComplaintComponent, canActivate: [ AuthGuard ] },
  { path: 'complaintDetails', component: ComplaintDetailsComponent, canActivate: [ AuthGuard ] },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [
  ]
})
export class ComplaintRoutingModule { }

